// {name, rigName: [OPTIONAL, name displayed on Performance DB], key, icon}
export const ANALYTICS_CARDS = {
  charts: {
    depthVDays: { name: 'Depth V Days', key: 'depthVDays', icon: 'ci:line-chart-down' },
    rigDays: { name: 'Rig Days', key: 'rigDays', icon: 'game-icons:oil-rig' },
    bhaResults: { name: 'BHA Results', key: 'bhaResults', icon: 'ant-design:pie-chart-outlined' },
    timeline: { name: 'Timeline', key: 'timeline', icon: 'mdi:timeline-clock-outline' },
    footageDashboard: { name: 'Distance Dashboard', key: 'footageDashboard', icon: 'tabler:ruler' },
    drillersComparisonKpi: {
      name: 'Drillers Comparison KPI',
      key: 'drillersComparisonKpi',
      icon: 'healthicons:miner-worker',
    },
    slideRotate: {
      name: 'Slide Rotate Distance/ROP',
      key: 'slideRotate',
      icon: 'ant-design:bar-chart-outlined',
    },
    slideRotateHours: {
      name: 'Slide Rotate Hours',
      key: 'slideRotateHours',
      icon: 'healthicons:chart-bar-stacked-outline',
    },
    activitySummary: { name: 'Activity Summary', key: 'activitySummary', icon: 'tdesign:activity' },
    activitySummaryDonut: {
      name: 'Activity Summary - Donut',
      key: 'activitySummaryDonut',
      icon: 'material-symbols:donut-small',
    },
    fastestWellKpi: { name: 'Fastest Well KPI', key: 'fastestWellKpi', icon: 'material-symbols:fast-forward-rounded' },
    longestWellKpi: { name: 'Longest Well KPI', key: 'longestWellKpi', icon: 'tabler:ruler-measure' },
    maxDrilledPerDayKpi: { name: 'Max Drilled Per Day KPI', key: 'maxDrilledPerDayKpi', icon: 'mdi:hours-24' },
    maxRopKpi: { name: 'Max ROP KPI', key: 'maxRopKpi', icon: 'ic:baseline-speed' },
    costPerWell: {
      name: 'Cost Per Well',
      key: 'costPerWell',
      icon: 'streamline:money-cash-bag-dollar-bag-payment-cash-money-finance',
    },
    costPerDay: { name: 'Cost Per Day', key: 'costPerDay', icon: 'mdi:finance' },
    costPerOperator: {
      name: 'Cost Per Operator',
      key: 'costPerOperator',
      icon: 'streamline:money-bank-institution-money-saving-bank-payment-finance',
    },
    costPerFt: { name: 'Cost Per Ft', key: 'costPerFt', icon: 'raphael:dollar' },
    costPerFtAssembly: {
      name: 'Cost Per Ft Assembly',
      key: 'costPerFtAssembly',
      icon: 'material-symbols:build-circle-outline',
    },
    footageRopByMotorMake: {
      name: 'Distance & ROP By Motor Make',
      key: 'footageRopByMotorMake',
      icon: 'game-icons:needle-drill',
    },
    footageRopByBit: { name: 'Distance & ROP By Bit', key: 'footageRopByBit', icon: 'game-icons:trefoil-shuriken' },
    boxWhiskersFootageByBit: {
      name: 'Box & Whiskers Distance By Bit',
      key: 'boxWhiskersFootageByBit',
      icon: 'fluent:data-whisker-20-regular',
    },
    boxWhiskersRopByBit: {
      name: 'Box & Whiskers ROP By Bit',
      key: 'boxWhiskersRopByBit',
      icon: 'fluent:data-whisker-20-filled',
    },
    footageRopByFormation: {
      name: 'Distance & ROP By Formation',
      key: 'footageRopByFormation',
      icon: 'carbon:soil-moisture',
    },
    footageRopByRig: { name: 'Distance & ROP By Rig', key: 'footageRopByRig', icon: 'game-icons:oil-rig' },
    footageRopByDirCo: { name: 'Distance & ROP By Directional Company', key: 'footageRopByDirCo', icon: 'ion:business' },
    footageRopByHoleSize: {
      name: 'Distance & ROP By Hole Size',
      key: 'footageRopByHoleSize',
      icon: 'carbon:drill-through',
    },
    footageRopByMotorConfig: {
      name: 'Distance & ROP By Motor Configuration',
      key: 'footageRopByMotorConfig',
      icon: 'carbon:ibm-engineering-lifecycle-mgmt',
    },
    footageRopByStatorType: {
      name: 'Distance & ROP By Stator Type',
      key: 'footageRopByStatorType',
      icon: 'icon-park-outline:oceanengine',
    },
    paramComparison: { name: 'Parameter Comparison', key: 'paramComparison', icon: 'carbon:chart-multi-line' },
    motorYield: { name: 'Motor Yield', key: 'motorYield', icon: 'lucide:bar-chart-horizontal' },
    tortuosityKpi: { name: 'Tortuosity', key: 'tortuosityKpi', icon: 'emojione-monotone:chart-increasing' },
    assemblyTypeFootageKpi: {
      name: 'Assembly Type Distance KPI',
      key: 'assemblyTypeFootageKpi',
      icon: 'mdi:pipe-wrench',
    },
    towerComparisonChartKpi: {
      name: 'Tower Comparison Chart',
      rigName: 'Tower Comparison',
      key: 'towerComparisonChartKpi',
      icon: 'game-icons:oil-rig',
    },
    connectionAnalysisRigChart: {
      name: 'Connection Analysis Rig Chart',
      key: 'connectionAnalysisRigChart',
      icon: 'mdi:pipe-disconnected',
      rigName: 'Connection Analysis Rig',
    },
    stallsCrossPlot: { name: 'Motor Performance Cross Plot', key: 'stallsCrossPlot', icon: 'ix:scatterplot' },
    stallsHeatMap: { name: 'Motor Performance Heat Map', key: 'stallsHeatMap', icon: 'ix:heat-map-chart-filled' },
  },
  grids: {
    wellRanking: { name: 'Well Ranking', rigName: 'Rig Ranking', key: 'wellRanking', icon: 'solar:ranking-outline' },
    directionalScoreCard: {
      name: 'Directional Score Card',
      key: 'directionalScoreCard',
      icon: 'grommet-icons:scorecard',
    },
    motorKpi: { name: 'Motor KPI', key: 'motorKpi', icon: 'game-icons:drill' },
    motorPerPhaseKpi: { name: 'BHA Grouped by Phase KPI', key: 'motorPerPhaseKpi', icon: 'grommet-icons:cluster' },
    phaseKpi: { name: 'Phase KPI', key: 'phaseKpi', icon: 'material-symbols:insert-chart-outline-sharp' },
    wellKpi: { name: 'Well KPI', key: 'wellKpi', icon: 'fa6-solid:oil-well' },
    holeSizeKpi: { name: 'Hole Size KPI', key: 'holeSizeKpi', icon: 'game-icons:hole' },
    daysKpi: { name: 'Days KPI', key: 'daysKpi', icon: 'mdi:calendar-today-outline' },
    activityKpi: { name: 'Activity KPI', key: 'activityKpi', icon: 'octicon:log-16' },
    inventoryKpi: { name: 'Inventory KPI', key: 'inventoryKpi', icon: 'ic:outline-inventory' },
    towerComparisonKpi: { name: 'Tower Comparison KPI', key: 'towerComparisonKpi', icon: 'game-icons:oil-rig' },
    connectionAnalysisWell: { name: 'Connection Analysis Well', key: 'connectionAnalysisWell', icon: 'ph:pipe-fill' },
    connectionAnalysisRig: {
      name: 'Connection Analysis Rig',
      key: 'connectionAnalysisRig',
      icon: 'mdi:pipe-disconnected',
    },
  },
}

export const flatAnalyticsMap = (useRigName) => {
  const flat = []
  Object.entries(ANALYTICS_CARDS).forEach(([_, groupObj]) => {
    Object.values(groupObj).forEach(({ name, rigName, key, icon }) => {
      flat.push({ label: useRigName ? rigName || name : name, value: key, icon: icon })
    })
  })

  flat.sort((a, b) => a.label.localeCompare(b.label))
  return flat
}

export const kpisTreeDefs = [
  {
    name: 'Depth v Days',
    key: '_DepthDays',
    expanded: false,
    children: [ANALYTICS_CARDS.charts.depthVDays],
  },
  {
    name: 'Activity',
    key: '_Activity',
    expanded: false,
    children: [
      ANALYTICS_CARDS.charts.rigDays,
      ANALYTICS_CARDS.charts.activitySummary,
      ANALYTICS_CARDS.charts.activitySummaryDonut,
      ANALYTICS_CARDS.charts.timeline,
      ANALYTICS_CARDS.charts.footageDashboard,
    ],
  },
  {
    name: 'Scorecards',
    key: '_Scorecards',
    expanded: false,
    children: [
      ANALYTICS_CARDS.grids.wellRanking,
      ANALYTICS_CARDS.grids.directionalScoreCard,
      ANALYTICS_CARDS.charts.fastestWellKpi,
      ANALYTICS_CARDS.charts.longestWellKpi,
      ANALYTICS_CARDS.charts.maxDrilledPerDayKpi,
      ANALYTICS_CARDS.charts.maxRopKpi,
    ],
  },
  {
    name: 'Cost',
    key: '_Cost',
    expanded: false,
    children: [
      ANALYTICS_CARDS.charts.costPerWell,
      ANALYTICS_CARDS.charts.costPerDay,
      ANALYTICS_CARDS.charts.costPerOperator,
      ANALYTICS_CARDS.charts.costPerFt,
      ANALYTICS_CARDS.charts.costPerFtAssembly,
    ],
  },
  {
    name: 'Distance/ROP',
    key: '_FootageROP',
    expanded: false,
    children: [
      ANALYTICS_CARDS.charts.footageRopByMotorMake,
      ANALYTICS_CARDS.charts.footageRopByBit,
      ANALYTICS_CARDS.charts.footageRopByFormation,
      ANALYTICS_CARDS.charts.footageRopByRig,
      ANALYTICS_CARDS.charts.footageRopByDirCo,
      ANALYTICS_CARDS.charts.footageRopByHoleSize,
      ANALYTICS_CARDS.charts.footageRopByMotorConfig,
      ANALYTICS_CARDS.charts.footageRopByStatorType,
      ANALYTICS_CARDS.charts.assemblyTypeFootageKpi,
      ANALYTICS_CARDS.charts.slideRotate,
      ANALYTICS_CARDS.charts.slideRotateHours,
      ANALYTICS_CARDS.charts.boxWhiskersFootageByBit,
      ANALYTICS_CARDS.charts.boxWhiskersRopByBit,
    ],
  },
  {
    name: 'Run Performance',
    key: '_Runs',
    expanded: false,
    children: [
      ANALYTICS_CARDS.grids.motorKpi,
      ANALYTICS_CARDS.grids.motorPerPhaseKpi,
      ANALYTICS_CARDS.charts.bhaResults,
      ANALYTICS_CARDS.charts.stallsCrossPlot,
      ANALYTICS_CARDS.charts.stallsHeatMap,
    ],
  },
  {
    name: 'Comparisons',
    key: '_Comparisons',
    expanded: false,
    children: [
      ANALYTICS_CARDS.grids.towerComparisonKpi,
      ANALYTICS_CARDS.charts.towerComparisonChartKpi,
      ANALYTICS_CARDS.charts.drillersComparisonKpi,
      ANALYTICS_CARDS.charts.paramComparison,
      ANALYTICS_CARDS.charts.motorYield,
      ANALYTICS_CARDS.charts.tortuosityKpi,
    ],
  },
  {
    name: 'Summaries',
    key: '_Summaries',
    expanded: false,
    children: [
      ANALYTICS_CARDS.grids.phaseKpi,
      ANALYTICS_CARDS.grids.wellKpi,
      ANALYTICS_CARDS.grids.holeSizeKpi,
      ANALYTICS_CARDS.grids.daysKpi,
      ANALYTICS_CARDS.grids.activityKpi,
      ANALYTICS_CARDS.grids.inventoryKpi,
    ],
  },
  {
    name: 'Connection Analysis',
    key: '_ConnectionAnalysis',
    expanded: false,
    children: [ANALYTICS_CARDS.grids.connectionAnalysisWell, ANALYTICS_CARDS.grids.connectionAnalysisRig, ANALYTICS_CARDS.charts.connectionAnalysisRigChart],
  },
]

export const PERFORMANCE_OPTIONS = [
  ANALYTICS_CARDS.charts.depthVDays,
  ANALYTICS_CARDS.charts.activitySummary,
  ANALYTICS_CARDS.charts.costPerWell,
  ANALYTICS_CARDS.charts.tortuosityKpi,
  ANALYTICS_CARDS.grids.wellRanking,
  ANALYTICS_CARDS.grids.directionalScoreCard,
  ANALYTICS_CARDS.charts.towerComparisonChartKpi,
  ANALYTICS_CARDS.charts.drillersComparisonKpi,
  ANALYTICS_CARDS.charts.connectionAnalysisRigChart,
  ANALYTICS_CARDS.charts.slideRotate,
  ANALYTICS_CARDS.charts.slideRotateHours,
  ANALYTICS_CARDS.charts.timeline,
  ANALYTICS_CARDS.charts.footageDashboard,
]

export const performanceTreeDefs = [
  {
    name: 'Options',
    key: '_Options',
    expanded: true,
    children: PERFORMANCE_OPTIONS,
  },
]

export const advFilterDefs = [
  {
    dropDownField: 'directionalCompanys',
    text: 'Dir Co.',
    value: [],
  },
  {
    dropDownField: 'holeSize',
    text: 'Hole Size',
    value: [],
  },
  {
    dropDownField: 'failure',
    text: 'Failure',
    value: [],
  },
  {
    dropDownField: 'motorSn',
    text: 'Motor SN',
    value: [],
  },
  {
    dropDownField: 'motorMake',
    text: 'Motor Make',
    value: [],
  },
  {
    dropDownField: 'bitMake',
    text: 'Bit Make',
    value: [],
  },
  {
    dropDownField: 'mwdType',
    text: 'MWD Type',
    value: [],
  },
  {
    dropDownField: 'driveType',
    text: 'Drive Type',
    value: [],
  },
  {
    dropDownField: 'motorLobes',
    text: 'Motor Lobes',
    value: [],
  },
  {
    dropDownField: 'motorStages',
    text: 'Motor Stages',
    value: [],
  },
  {
    text: 'Serial #',
    type: 'text',
    value: [],
  },
  {
    text: 'Assembly Type',
    dropDownField: 'assemblyType',
    value: [],
  },
  {
    text: 'Mud Type',
    dropDownField: 'mudType',
    value: [],
  },
  {
    text: 'Rental jobs',
    dropDownField: 'rentalJobs',
    value: [],
  },
  { dropDownField: 'isLih', text: 'LIH', value: [] },
]
